<template>
  <div class="report_index">
    <div class="report_cate">
      <el-icon class="el-icon-document-copy"></el-icon> 报案记录
    </div>
    <div class="report_box" v-infinite-scroll="loadMore">
      <div class="report_empty" v-if="reports.length<=0">
        暂无记录
      </div>
      <div class="report_one" v-for="(item,index) in reports" :key="index" @click="toReview(item.rid)">
        <div class="report_info">
          <div class="report_left">
            {{new Date(item.utime*1000).toLocaleString()}}
          </div>
          <div class="report_right" :style="`color:`+statesColor[item.state]+`;`">
            {{states[item.state]}}
          </div>
        </div>
        <div class="report_title">
          <div class="report_left">
            船名: <el-tag>{{item.shipname}}</el-tag>
          </div>
          <div class="report_right">
            单号: {{item.policy_number}}
          </div>
        </div>
      </div>
    </div>
    <div class="report_bottom">
      <el-button type="danger" style="width:90%;margin:0 5%;" @click="toAdd">立即报案</el-button>
    </div>
  </div>
</template>

<script>
  import { reportSearch } from '../../api/api'

  export default {
    name: "ReportIndex",
    data() {
      return {
        reports:[],
        params:{},
        page:1,
        size:10,
        loading:false,
        states:['待处理','处理中','已处理'],
        statesColor:['red','orange','success']
      }
    },
    mounted() {

    },
    methods: {
      loadMore(){
        if (!this.loading) {
          this.loading = true;
          let params = JSON.parse(JSON.stringify(this.params));
          params['page'] = this.page;
          params['size'] = this.size;
          reportSearch(params).then(res => {
            if (res && res.status === 0 && res.data) {
              for (let d in res.data) {
                this.reports.push(res.data[d]);
              }
              this.page++;
            }
            this.loading = false;
          });
        }
      },
      toReview(rid){
        this.$router.push('/report/review?rid='+rid);
      },
      toAdd(){
        this.$router.push('/report/add')
      }
    }
  }
</script>

<style scoped>
  .report_index {
    top: 6vh;
    left: 0;
    position: absolute;
    height: 94vh;
    width: 100%;
    margin: 0;
    background-color: #eee;
  }
  .report_box {
    height:80vh;
    width:94%;
    margin:2vh 3%;
    overflow-y: scroll;
  }
  .report_cate {
    font-size:.9rem;
    font-weight:bold;
    height:2rem;
    line-height:2rem;
    border-bottom:1px dashed grey;
    text-indent: .3rem;
    color:#03a7d5;
  }
  .report_one {
    width:100%;
    height:5rem;
    line-height:5rem;
    margin-bottom:2vh;
    border-bottom:1px dashed grey;
  }
  .report_title {
    height:2.5rem;
    line-height:2.5rem;
    font-size:.8rem;
    font-weight:bold;
    color:#3f3f3f;
    width:100%;
  }
  .report_info {
    height:2rem;
    line-height:2rem;
    width:100%;
    font-size:.8rem;
    color:grey;
    text-align:left;
  }
  .report_left {
    width:50%;
    float:left;
    overflow-x: hidden;
  }
  .report_right {
    width:50%;
    float:right;
    overflow-x: hidden;
  }
  .report_bottom {
    width:100%;
    position:fixed;
    bottom:0;
    height:4.8rem;
    line-height:4.8rem;
    border-top:1px #ddd dashed;
  }
  .report_empty {
    width:100%;
    text-align:center;
    color:grey;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/index.vue